import { Box, Button, ButtonProps, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ConfigurationStatus } from '~graphql/__generated__/types';

export type ConfigurationStatusType =
  | ConfigurationStatus.Draft
  | ConfigurationStatus.Published
  | ConfigurationStatus.Readytopublish;

export const StateButton = ({
  state,
  currentState,
  ...buttonProps
}: {
  state: ConfigurationStatusType;
  currentState: ConfigurationStatusType;
} & ButtonProps) => {
  const { t } = useTranslation();
  const isActive = state === currentState;
  const styles: ButtonProps = {
    py: 2,
    variant: 'ghost',
    fontSize: 'small',
    fontWeight: 'normal',
    borderRadius: 5,
    height: 6,
    bg: isActive
      ? state === ConfigurationStatus.Published
        ? 'green.400'
        : 'orange.300'
      : undefined,
    color: isActive ? 'white' : undefined,
    _hover: isActive
      ? {}
      : {
          color: 'blue.500',
        },
    ...buttonProps,
  };

  return (
    <Button {...styles}>
      {state === ConfigurationStatus.Published ? t('published') : t('draft')}
    </Button>
  );
};

export const ConfigurationStateToggle = ({
  onStateChange,
  value = ConfigurationStatus.Published,
  ...buttonProps
}: {
  onStateChange: (state: ConfigurationStatusType) => void;
  value?: ConfigurationStatusType;
} & ButtonProps) => {
  const onClick = (state: ConfigurationStatusType) => {
    onStateChange(state);
  };

  return (
    <Box border="1px solid" p="1px" borderRadius={6} w="min-content" mt={2}>
      <HStack gap={0} role="group" aria-label="Configuration state toggle">
        <StateButton
          state={ConfigurationStatus.Published}
          w={24}
          currentState={value}
          onClick={() => onClick(ConfigurationStatus.Published)}
          {...buttonProps}
        />
        <StateButton
          state={ConfigurationStatus.Draft}
          w={20}
          currentState={
            value === ConfigurationStatus.Readytopublish ? ConfigurationStatus.Draft : value
          }
          onClick={() => onClick(ConfigurationStatus.Draft)}
          {...buttonProps}
        />
      </HStack>
    </Box>
  );
};
